import Subject from "../cse4sub/Subject";
import React from 'react'
import CSE305 from '../assets/CSE305end21.pdf'

export default function AecLab() {
  return (
    <div>
       <Subject title="Analog Electronic Circuit Lab(CSE305)" sub="AEC Lab" syllabus="#"
    book1=" " book2=" "
    book1Link="#" book2Link="#" int21="#" mid21="#" end21={CSE305}
     int20="#" mid20="#" end20="#" mid="---"
    />
    </div>
  )
}